import { render, staticRenderFns } from "./DecisionCommitteeViewModal.vue?vue&type=template&id=3615c594"
import script from "./DecisionCommitteeViewModal.vue?vue&type=script&lang=js"
export * from "./DecisionCommitteeViewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports